import { create } from 'zustand'

export interface CameraPosition {
  x: number
  y: number
  z: number
}

export interface ModelRotation {
  x: number
  y: number
  z: number
}

export interface ViewerState {
  isLoading: boolean
  error: string | null
  cameraPosition: CameraPosition
  modelRotation: ModelRotation
  setLoading: (isLoading: boolean) => void
  setError: (error: string | null) => void
  setCameraPosition: (position: CameraPosition) => void
  setModelRotation: (rotation: ModelRotation) => void
  resetError: () => void
}

export const useViewerStore = create<ViewerState>((set) => ({
  isLoading: false,
  error: null,
  cameraPosition: { x: -150, y: 50, z: 150 },
  modelRotation: { x: 0, y: 0, z: 0 },
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  setCameraPosition: (cameraPosition) => set({ cameraPosition }),
  setModelRotation: (modelRotation) => set({ modelRotation }),
  resetError: () => set({ error: null }),
}))
